export type EmailNotificationTagKeys = 'upload';

export function createEmailNotificationTag(tagKey: EmailNotificationTagKeys, value?: string): string {
    return `{${tagKey}${value ? `:${value}` : ''}}`;
}

export type EmailNotificationTag<K extends EmailNotificationTagKeys = EmailNotificationTagKeys> = {
    key: K;
    fromIndex: number;
    toIndex: number;
    match: string;
    value?: string;
};

export function getAllEmailNotificationTags(htmlContent: string): EmailNotificationTag[] {
    const regex = new RegExp(/{[^:{]+?(?=}?)(:[^:{}]+)?}/g);

    const tags: EmailNotificationTag[] = [];
    let match;
    while ((match = regex.exec(htmlContent)) !== null) {
        const matchedString = match[0];
        const colonIndex = matchedString.indexOf(':');
        const endIndex = matchedString.indexOf('}');
        const tagKey = matchedString.substring(1, colonIndex >= 0 ? colonIndex : endIndex);
        const tagValue = colonIndex >= 0 ? matchedString.substring(colonIndex + 1, endIndex) : undefined;
        tags.push({
            fromIndex: match.index,
            key: tagKey as EmailNotificationTagKeys,
            match: matchedString,
            toIndex: regex.lastIndex,
            value: tagValue,
        });
    }

    return tags;
}

export function getEmailNotificationTags<K extends EmailNotificationTagKeys>(
    htmlContent: string,
    tagKey: K,
): Array<EmailNotificationTag<K>> {

    return getAllEmailNotificationTags(htmlContent).filter((tag): tag is EmailNotificationTag<K> => tag.key === tagKey);
}
